export const getMetricsValues = (theme) => [
  {
    label: 'Government',
    color: theme?.mmtPrimary7,
    toggled: true,
    key: 'government',
  },
  {
    label: 'Civil Society',
    color: '#0059AB',
    toggled: true,
    key: 'civilSociety',
  },
  {
    label: 'Business',
    color: '#86C0F5',
    toggled: true,
    key: 'businessEntity',
  },
  {
    label: 'Other',
    color: '#ADADAD',
    toggled: true,
    key: 'other',
  },
];
